import React from 'react'

const Bookhoteldata = () => {
  return (
    <div><h1>Helooooooo</h1></div>
  )
}

export default Bookhoteldata